import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';

import {
  map,
  mergeMap,
  catchError,
  switchMap,
  concatMap
} from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';

import {
  entitySitiosProcesamientoLoadRequest,
  entitySitiosProcesamientoLoadFailure,
  entitySitiosProcesamientoLoadSuccess,
  entitySitiosProcesamientoAddFailure,
  entitySitiosProcesamientoAddRequest,
  entitySitiosProcesamientoAddSuccess,
  entitySitiosProcesamientoDeleteRequest,
  entitySitiosProcesamientoDeleteSuccess
} from './sitios-procesamiento.actions';

import { SitiosProcesamientoService } from './sitios-procesamiento.service';
import { NotificationService } from '../../../core/core.module';

@Injectable()
export class SitiosProcesamientoEffects {
  // load
  loadRequestSitiosProcesamiento = createEffect(() =>
    this.actions$.pipe(
      ofType(entitySitiosProcesamientoLoadRequest),
      mergeMap(() =>
        this.sitiosProcesamientoService.getSitiosProcesamiento().pipe(
          map((items) => entitySitiosProcesamientoLoadSuccess({ items })),
          catchError((error) =>
            of(entitySitiosProcesamientoLoadFailure({ error }))
          )
        )
      )
    )
  );

  // add
  addRequestSitiosProcesamiento = createEffect(() =>
    this.actions$.pipe(
      ofType(entitySitiosProcesamientoAddRequest),
      switchMap((action) =>
        this.sitiosProcesamientoService
          .addSitiosProcesamiento(action.item)
          .pipe(
            concatMap((item) => [
              entitySitiosProcesamientoAddSuccess({ item })
            ]),
            catchError((error) =>
              of(entitySitiosProcesamientoAddFailure({ error }))
            )
          )
      )
    )
  );

  addSuccessSitiosProcesamiento = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entitySitiosProcesamientoAddSuccess)
        //tap(() => this.router.navigate(['']))
      ),
    { dispatch: false }
  );

  deleteRequestSitioProcesamiento = createEffect(() =>
    this.actions$.pipe(
      ofType(entitySitiosProcesamientoDeleteRequest),
      mergeMap((action) =>
        this.sitiosProcesamientoService
          .deleteSitiosProcesamiento(action.item)
          .pipe(
            map((item) => {
              this.alertService.success(
                'Sitio procesamiento eliminado correctamente.'
              );
              return entitySitiosProcesamientoDeleteSuccess({
                item: action.item
              });
            }),
            catchError((error) =>
              of(entitySitiosProcesamientoLoadFailure({ error }))
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private sitiosProcesamientoService: SitiosProcesamientoService,
    private router: Router,
    private alertService: NotificationService
  ) {}
}
